import classNames from 'classnames';
import { useTranslator } from '@picsart/rc/services/localization';

import {
  Button,
  ButtonSizeMD,
  ButtonSkinAbsoluteWhite,
  ButtonVariants,
} from '@picsart/design-system/components/Button';

import Media from 'redesignedComponents/molecules/Media';

import SocialMediaIcon from 'components/SocialMediaIcon';
import { dataTestIds } from '../constants';
import { MediaItemProps } from './types';
import useStyles from './styles';

const MediaItem = ({ redirectUrl, title, icon, image }: MediaItemProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  const media = {
    imageSrc: image?.src,
    alt: image?.alt || title,
    imageClassName: classes.image,
  };

  return (
    <a
      href={redirectUrl}
      className={classNames(classes.root, classes.showAllLink)}
      data-pulse-name={title}
      data-testid={dataTestIds.mediaItem}
    >
      {icon ? (
        <SocialMediaIcon icon={icon} className={classes.mediaWrapper} />
      ) : (
        <Media media={media} className={classes.mediaWrapper} dataTestId={dataTestIds.image} />
      )}
      <p>{translate(title)}</p>
      <Button
        data-pulse-name={title}
        variant={ButtonVariants.Filled}
        size={ButtonSizeMD}
        skin={ButtonSkinAbsoluteWhite}
        className={classes.showAll}
      >
        {translate('Show All')}
      </Button>
    </a>
  );
};

export default MediaItem;
